import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {I18NextTitle} from 'angular-i18next';

@Component({
    selector: 'page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundComponent implements OnInit {
    constructor(private title: I18NextTitle) {}

    ngOnInit() {
        this.title.setTitle('errors.404.page_title');
    }

    /* istanbul ignore next */
    onClickToBack() {
        window.history.back();
    }
}
